<template>
  <div class="panel-body">
    <h4 v-if="showUsers.Message">Message: {{ showUsers.Message }}</h4>
    <!-- <h5>{{showMessage}}</h5> -->
    <h1 class="logo-desc">Programming Hub</h1>

    <!--============== LOADER ================-->
    <div v-if="loader">
      <ball-triangle-path-loader color="#000000" size="20px"></ball-triangle-path-loader>
    </div>
    <!--================ LOADER ENDS ==============-->
    <!--================ ALERT ==================-->
    <div class="alert alert-success alert-dismissible" v-if="showMessage">
      <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
      Congratulations user: {{ showData.newAddedUser }} has been created!
    </div>
    <!--================ ALERT ENDS =================-->
    <!--================== SEARCH BOX =================-->
    <!-- <div class="customWidth">
      <form @submit.prevent="getUser">
        <div>
          <label for="usr">Email:</label>
          <input type="email" class="form-control" v-model="searchUser" placeholder="enter email">
        </div>
        <br>
        <button type="submit" class="btn btn-primary">Search</button>
      </form>
    </div>-->
    <br>
    <!--================== SEARCH BOX ENDS=================-->
    <!--================== addUser Form=================-->
    <div class="form-container">
      <form @submit.prevent="submit">
        <h4>Add user</h4>
        <div class="form-group">
          <label for="email">Email</label>
          <input
            type="email"
            class="form-control"
            id="email"
            v-model="email"
            placeholder="Enter email"
          >
        </div>
        <!-- <div class="form-group">
          <label for="name">Name</label>
          <input
            type="text"
            class="form-control"
            id="name"
            aria-describedby="emailHelp"
            placeholder="Enter Name"
          >
        </div>-->
        <div class="form-group">
          <label for="password">Password</label>
          <input
            type="password"
            class="form-control"
            v-model="password"
            id="password"
            placeholder="Password"
          >
        </div>
        <div class="form-group">
          <label for="role">Role</label>
          <div v-for="data in showData.access" :key="data.id" style="display: flex;">
            <!-- <span>{{data.pagename}}</span> -->
            <input
              type="checkbox"
              :value="data.id"
              :id="data.id"
              v-model="checkedCategories"
              @click="setAccedId($event)"
            >
            <label :for="data.id" class="checkbox-control">{{data.pagename}}</label>
          </div>
        </div>
        <!-- <div class="form-check">
          <input type="checkbox" class="form-check-input" id="exampleCheck1">
          <label class="form-check-label" for="exampleCheck1">Check me out</label>
        </div>-->
        <button class="btn btn-primary btn-float-right" type="submit">Submit</button>
      </form>
    </div>
    <!--================== addUser Form ENDS=================-->
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import "vue-loaders/dist/vue-loaders.css";
import * as VueLoaders from "vue-loaders";
Vue.use(VueLoaders);
export default {
  name: "addUser",
  computed: {
    ...mapGetters({
      showData: "showData",
      showUsers: "showUsers",
      showMessage: "showMessage",
      loader: "showLoader"
    }),
    searchUser: {
      set: function(val) {
        this.$store.commit("updateSearchUser", val);
      },
      get: function() {
        return this.showData.searchUser;
      }
    },
    email: {
      set: function(val) {
        this.$store.commit("updateAddEmail", val);
      },
      get: function() {
        return this.showData.addEmail;
      }
    },
    password: {
      set: function(val) {
        this.$store.commit("updateAddPassword", val);
      },
      get: function() {
        return this.showData.addPassword;
      }
    },
    checkedCategories: {
      set: function(val) {
        this.$store.commit("updateCheckedCategories", val);
      },
      get: function() {
        return this.showData.checkedCategories;
      }
    }
  },
  mounted() {
    // this.getUser();
    this.modeSet();
  },
  methods: {
    ...mapActions(["searchUser_", "setMode", "resetPassword_", "addUser"]),
    getUser: function() {
      this.searchUser_({
        mode: this.showData.mode
      });
      this.searchUser = null;
    },
    modeSet: function() {
      this.setMode({ mode: this.showData.mode });
    },
    resetPassword: function() {
      this.resetPassword_({ mode: this.showData.mode });
    },
    setAccedId: function(e) {
      if (e.target.checked) {
        console.log(e.target.value, this.checkedCategories);
      }
    },
    submit: function() {
      // console.log('calls');

      this.addUser({
        idArray: this.checkedCategories,
        mode: this.showData.mode
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-container {
  margin: 0 auto;
  width: 30%;
}
.checkbox-control {
  margin-left: 15px;
}
</style>
